import {useEffect} from "react";

import {controllerSellerApp} from "../../../../services/controllers/service-activation";
import {NewUser} from "./new-user";
import {UserList} from "./user-list";


export function SellerApp(){
  const CLSellerApp = controllerSellerApp()

  useEffect(()=>{
    CLSellerApp.getUsers()
  },[])

  return(
    <div className="flex flex-col gap-6 w-full">
      <NewUser />
      <UserList />
    </div>
  )
}
